import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout';
import MapPage from '../pages/MapPage';
import MenuPage from '../pages/MenuPage';
import EquipmentsPage from '../pages/EquipmentsPage';
import AlertsPage from '../pages/AlertsPage';
import LightsPage from '../pages/LightsPage';
import SchedulePage from '../pages/SchedulePage';
import EnergyPage from '../pages/EnergyPage';
import ProfilePage from '../pages/ProfilePage';
import SecurityPage from '../pages/SecurityPage';
import { usePolesContext } from '../modules/poles/PolesContext';

const PrivateRoutes = () => {
  const { isLoading, currentPole } = usePolesContext();

  if (isLoading) return <Layout />;

  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Redirect to Intro after success login */}
        <Route path="login" element={<Navigate to="/" replace />} />
        {/* Pages */}
        <Route path="profile" element={<ProfilePage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route
          path="map"
          element={currentPole ? <Navigate to="/menu" replace /> : <MapPage />}
        />
        {currentPole && (
          <>
            <Route path="menu" element={<MenuPage />} />
            <Route path="equipments" element={<EquipmentsPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            {(currentPole.firmware.ledrgb.allowed ||
              currentPole.firmware.ledw.allowed) && (
              <>
                <Route path="lights" element={<LightsPage />} />
                <Route path="schedule" element={<SchedulePage />} />
              </>
            )}
            <Route path="energy" element={<EnergyPage />} />
          </>
        )}
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/map" replace />} />
      </Route>
    </Routes>
  );
};

export default PrivateRoutes;
